import { useEffect } from "react";
import ShopCard from "../components/ShopCard";
import { useDispatch, useSelector } from 'react-redux'
import logo from '../images/logo.png';
import { getPositionAsync } from '../redux/positionSlice.js';
import { getAllData } from "../redux/shopsSlice.js";

const HomePage = () => {
    const dispatch = useDispatch();
    const shopsArray = useSelector(state => state.shops.data.payload);
    const fetchStatus = useSelector(state => state.shops.fetchStatus);
    const reduxPositionData = useSelector(state => state.position);

    useEffect(() => {
        dispatch(getPositionAsync());
    }, []);

    useEffect(() => {
        if(reduxPositionData.lat !== null) {
            console.log('HOMEPAGE reduxPositionData: ', reduxPositionData);
            dispatch(getAllData(reduxPositionData));
        }
    }, [reduxPositionData])
    

    return (
        <div className="main-container">
            <div className="spiedo mt-8"></div>
            <img src={logo} alt="Spiedoaway logo" className="w-[300px] md:w-[400px] mb-8" />
            {
                (fetchStatus === 'loading' || fetchStatus === 'idle') ? (
                    <div className="custom-loader"></div>
                ) : (
                    fetchStatus === 'succeeded' ? (
                        <div className="w-full flex flex-wrap gap-8 justify-evenly">
                            {
                                shopsArray && shopsArray.map((element, index) => (
                                    <ShopCard
                                        key={index}
                                        shopId={element._id}
                                        name={element.name}
                                        mainPhone={element.mainPhone}
                                        secondaryPhone={element.secondaryPhone}
                                        position={element.position}
                                        email={element.email}
                                        website={element.website}
                                        isPremium={element.isPremium}
                                        portionPrice={element.portionPrice}
                                        availableDays={element.availableDays}
                                        shopAvatar={element.shopAvatar}
                                        copy={element.copy}
                                        reviews={element.reviews}
                                        offerProducts={element.offerProducts}
                                        owner={element.owner}
                                        distance={element.distance}
                                    />
                                ))
                            }
                        </div>
                    ) : (
                        fetchStatus === 'failed' ? (
                            <>
                                <h3>Qualcosa è andato storto, ricarica la pagina.</h3>
                                <h3>:(</h3>
                            </>
                        ) : (
                            <></>
                        )
                    )
                )
            }
        </div>
    )
}

export default HomePage;